import { getCookie } from '.';

export const isAppointmentSetupEnabled = () => !!(getCookie('cdlThrottleList') && getCookie('cdlThrottleList')?.includes('FWA_Pro_T_Install'));
